var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTimer)?_c('div',[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" "),_c('span',[_vm._v("0:"+_vm._s(_vm.checkSeconds))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }